const invoiceregisterRefresh = {
  state: {
    confimed: false,
  },
  getters: {
    deleteInvoiceConfirmed(state) {
      return state.confimed;
    },
  },
  mutations: {
    UPDATE_CONFIRMED(state, payload) {
      state.confimed = payload;
    },
  },
};

export default invoiceregisterRefresh;
